<template>
    <!--<iframe width="100%" height="100%" src="https://chaperon.tunetoo.com"></iframe>-->
    <div id="tunetooShop">
        <iframe width="100%" height="1453" src="https://chaperon.tunetoo.com" frameborder="0"></iframe>
        <p align="center" style="margin-bottom: 10px;">
          Site en partenariat avec tunetoo spécialite de la  <a href="https://www.tunetoo.com/coque-personnalisee.php" target="_blank">Coque de téléphone personnalisée</a>.
        </p>
    </div>
</template>

<script>
import quizzes from './resources/quizz.json'
export default {
  name: 'coming',
  data () {
    return {
      selected: '',
      quizes: quizzes,
      user: {full_name: '', email: '', age: '', job: '', gender: '', q_id: '', from: 'Newsletter'},
      loading: false,
      toast_options: {position: 'bottom-right', duration: 5000, theme: 'primary', type: 'success', action: {text: 'FERMER', onClick: (e, toastObject) => { toastObject.goAway(0) }}}
    }
  },
  mounted () { /*
    this.$contact = this.$resource('messages', {from: 'Chaperon Contact<no-reply@chaperon.me>', to: 'wachiepo@gmail.com', subject: 'New Contact', text: 'Wecome punk', multipart: true}, {}, {
      before: () => { this.loading = true },
      after: () => { this.loading = false }
    })
    */
    this.resource = this.$resource('mailer')
  },
  methods: {
    sendMail: function () {
           // you can call like this in your component
      this.$toasted.show('Envoi en cours...', this.toast_options)
      this.resource.save({}, {user: this.user, result: null}).then(function (response) {
        // you can call like this in your component
        this.$toasted.show('Merci  pour votre participation ! <3', this.toast_options)
        this.loading = true
        console.log('Success!:', response.data)
      }, function (error) {
        this.loading = false
        console.log('Error!:', error)
      })
    },
    selectQuizz (event) {
      this.selected = event.target.value
    },
    goToQuizz () {
      if (this.selected !== '') {
        this.$router.push({path: '/quizz/' + this.selected})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Shop.vue?81a8391c